import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachThucTapPhamViSinhVienInsertRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienInsertRequest";
import { IKeHoachThucTapPhamViSinhVienSelectRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienSelectRequest";
import { IKeHoachThucTapPhamViSinhVienViewModel } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapPhamViSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachThucTapPhamViSinhVienActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: {} as IKeHoachThucTapPhamViSinhVienSelectRequest,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: [] as IKeHoachThucTapPhamViSinhVienViewModel[],
    LOAD_BY_DOT_THUC_TAP_ERROR: "",

    INSERTS_START: {} as IKeHoachThucTapPhamViSinhVienInsertRequest,
    INSERTS_SUCCESS: undefined,
    INSERTS_ERROR: "",

    DELETES_START: {} as IIdsRequest,
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP: {} as boolean,
}

export const eKeHoachThucTapPhamViSinhVienActionIds = generateActionTypeIds(eKeHoachThucTapPhamViSinhVienActionsObj, "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN");
export type IKeHoachThucTapPhamViSinhVienActionTypes = IGenericActionType<typeof eKeHoachThucTapPhamViSinhVienActionsObj, "KE_HOACH_THUC_TAP_PHAM_VI_SINH_VIEN">;